
import { term } from '../../../util/formula';

import { STATE, MUTATIONS, ACTIONS } from '../../../storeConstants';

export default {
  [ACTIONS.UPDATE_INSURANCE_COST]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_HOA]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_PROPERTY_TAX]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_ONE_TIME_PAYMENT_AMOUNT]({ commit }, payload) {
    commit(MUTATIONS.CHANGE_ONE_TIME_PAYMENT_AMOUNT, payload);
  },
  [ACTIONS.UPDATE_PRINCIPLE]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_EXTRA]({ commit, state, getters }, { value }) {
    const newTerm = term({ ...state, PAYMENT: (getters.PAYMENT + value) });
    const newModifyTerm = (state.TERM - newTerm);
    commit(MUTATIONS.CHANGE, { target: STATE.MODIFY_TERM, value: newModifyTerm });
  },
  [ACTIONS.UPDATE_TERM]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },

  [ACTIONS.UPDATE_INTEREST_RATE]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_ANNUAL_PAYMENT_AMOUNT]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_ONE_TIME_PAYMENT_AMOUNT]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_ONE_TIME_PAYMENT_DATE]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_ANNUAL_PAYMENT_DATE]({ commit }, payload) {
    // const valueInt = !!value || !!parseInt(value, 10) ? parseInt(value, 10) : 1;
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_DOWNPAYMENT]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
  [ACTIONS.UPDATE_MORTGAGE_START_DATE]({ commit }, payload) {
    commit(MUTATIONS.CHANGE, payload);
  },
};
